/** Default SEO link block size from the API. */
export const DEFAULT_MAX_LINKS_PER_SECTION = 15;

/** Curated homepage (e.g. en-US with POIs) sends more links per section. */
export const CURATED_HOMEPAGE_MAX_LINKS_PER_SECTION = 50;
